import {
  ContactAddressDetail,
  ContactAddressPostalCode,
  ContactAddressPrefecture,
} from '@/components/ContactAddressSetting';
import { InputBaseType } from '@/components/ReportForm/InputBase/types';
import classnames from 'classnames/bind';
import { memo } from 'react';
import { FieldValues, Path } from 'react-hook-form';
import styles from './ApPayeeFormInputContactAddress.module.scss';

const cx = classnames.bind(styles);

export type Props<TFieldValues extends FieldValues> = Omit<
  InputBaseType<TFieldValues>,
  'name' | 'label' | 'tooltip' | 'caption' | 'hidden'
> & {
  postalCodeName: Path<TFieldValues>;
  prefectureIdName: Path<TFieldValues>;
  addressName: Path<TFieldValues>;
};

const InnerApPayeeFormInputContactAddress = <TFieldValues extends FieldValues>({
  control,
  inputId,
  required = false,
  postalCodeName,
  prefectureIdName,
  addressName,
}: Props<TFieldValues>) => {
  return (
    <div className={cx('container')}>
      <div className={cx('row')}>
        <div className={cx('postalCode')}>
          <ContactAddressPostalCode<TFieldValues>
            control={control}
            name={postalCodeName}
            inputId={`${inputId}-postal-code`}
            required={required}
          />
        </div>
        <div className={cx('prefecture')}>
          <ContactAddressPrefecture<TFieldValues>
            control={control}
            name={prefectureIdName}
            inputId={`${inputId}-prefecture`}
            required={required}
          />
        </div>
      </div>
      <ContactAddressDetail<TFieldValues>
        control={control}
        name={addressName}
        inputId={`${inputId}-address`}
        required={required}
      />
    </div>
  );
};

InnerApPayeeFormInputContactAddress.displayName =
  'InnerApPayeeFormInputContactAddress';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const ApPayeeFormInputContactAddress = memo((props) => (
  <InnerApPayeeFormInputContactAddress {...props} />
)) as typeof InnerApPayeeFormInputContactAddress;
ApPayeeFormInputContactAddress.displayName = 'ApPayeeFormInputContactAddress';
